import { Component, Input, OnInit } from '@angular/core';
import { WizardComponent } from '../../wizard/wizard.component';
import { Application } from '../../../models/application';
import { FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-step-amount',
  templateUrl: './amount.component.html',
  styleUrl: './amount.component.scss'
})
export class AmountComponent implements OnInit {
  @Input() application: Application;

  @Input() formGroupName: string;
  form: FormGroup;

  constructor(
    private rootFormGroup: FormGroupDirective,
    private wizardComponent: WizardComponent,
  ) { }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }
}
